import { render, staticRenderFns } from "./SecurityManage.vue?vue&type=template&id=44014cbe&scoped=true&"
import script from "./SecurityManage.vue?vue&type=script&lang=js&"
export * from "./SecurityManage.vue?vue&type=script&lang=js&"
import style0 from "./SecurityManage.vue?vue&type=style&index=0&id=44014cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44014cbe",
  null
  
)

export default component.exports